import type { ArrangementTemplateDto } from '@pams/shared';

/**
 * ─────────────────────────────────────────────────────────────────────────────────────
 *  [TEMPLATE-FIND] WHAT A LINK INTO THIS TEMPLATE POINTS AT — one of its duty points (`?point=g1.d34`) or
 *  one of its printed totals (`?check=p16:t6`), as `templateHref` in `lib/templateLinks.ts` builds them.
 *
 *  ⚠️ READ FROM THE CURRENT URL ON EVERY RENDER, NEVER HELD AS STATE. The pane is reused while the URL
 *  moves underneath it — another template, another row of this one — and a target copied into state on
 *  mount would go on marking the row a person has since left.
 *
 *  ⚠️ A TARGET THIS TEMPLATE DOES NOT HOLD IS NO TARGET. A stale or hand-edited link shows the plain pane
 *  rather than a marker on nothing, and a point wins over a check when a link somehow carries both.
 * ─────────────────────────────────────────────────────────────────────────────────────
 */
export type LinkedTarget =
  { readonly kind: 'point'; readonly key: string } | { readonly kind: 'check'; readonly id: string } | null;

export const linkedTargetOf = (
  search: URLSearchParams,
  data: Pick<ArrangementTemplateDto, 'groups' | 'checks'>,
): LinkedTarget => {
  const point = search.get('point');
  if (point !== null && data.groups.some((group) => group.dutyPoints.some((entry) => entry.key === point))) {
    return { kind: 'point', key: point };
  }
  const check = search.get('check');
  if (check !== null && data.checks.some((entry) => entry.id === check)) return { kind: 'check', id: check };
  return null;
};
